import React, { useEffect } from "react";
import { Bars3Icon } from "@heroicons/react/24/outline";
import { useNCallContext } from "../../context/ncall-context";

import { ToastContainer } from "react-toastify";
import Sidebar from "../../components/sidebar";
import { Outlet, useNavigate } from "react-router-dom";
import { showInfoToast } from "../../utils/toast";

const Admin = () => {
  const { setOpenSideBar, getAllClients, dispatch } = useNCallContext();

  const navigate = useNavigate();
  useEffect(() => {
    dispatch({ type: "LOADING", payload: true });
    if (localStorage.getItem("logged-in-as") == "client") {
      navigate("/client");
    }

    // Adding this code to clear the local storage if the scheduler variable is set to default values.
    const schedulerState = localStorage.getItem("scheduler");
    if (
      schedulerState === null ||
      schedulerState === "f4b7a1e0-5a2f-4a39-a548-1c7b993e1c13" ||
      schedulerState === "c69ad4b4-99d9-43ea-bb4b-f3cc762a9d12"
    ) {
      console.log(
        "Clearing the scheduler variable state and restarting the application. Value: ",
        schedulerState
      );
      showInfoToast("App is being updated. Please enter the code again.");

      setTimeout(() => {
        localStorage.clear();
        window.location.reload();
      }, 3000);
    }
  }, []);

  useEffect(() => {
    getAllClients();
  }, []);

  return (
    <>
      <Sidebar />

      <div className="flex flex-1 flex-col md:pl-64">
        <div className="sticky top-0 z-10 bg-gray-100 pl-1 pt-1 sm:pl-3 sm:pt-3 md:hidden">
          <button
            type="button"
            className="-ml-0.5 -mt-0.5 inline-flex h-12 w-12 items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
            onClick={() => setOpenSideBar(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>

        <main className="flex-1">
          <div className="py-6">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8 h-screen">
              <Outlet />
            </div>
          </div>
        </main>
      </div>
      <ToastContainer />
    </>
  );
};

export default Admin;
